import { PoliciesMatrix } from '@/features/decisions/components/policies/PoliciesMatrix';

export function Policies() {
  return <PoliciesMatrix />;
}
